import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { technicalInformationFormFields } from '../../constants/formsAddEquipment';
import { hydrogenTechnologyType } from '../../constants/classificators';

export default createValidation([
  {
    name: technicalInformationFormFields.HYDROGEN_TECHNOLOGY_TYPE,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: technicalInformationFormFields.ELECTROLYSIS_TECHNOLOGY_TYPE,
    // Require only when HYDROGEN_TECHNOLOGY_TYPE === ELECTROLYSIS
    validators: (field, form) => {
      const tech = form.get(
        technicalInformationFormFields.HYDROGEN_TECHNOLOGY_TYPE
      );
      return tech === hydrogenTechnologyType.ELECTROLYSIS
        ? validatorRequired()(field)
        : undefined;
    },
  },
  {
    name: technicalInformationFormFields.RFNBO,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: technicalInformationFormFields.NOMINAL_POWER,
    validators: (field) => validatorRequired()(field),
  },
]);
